import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FormModal from '../../components/Modals/FormModal';
import InputField from '../../components/Forms/Input/InputField';

interface EconomicActivityPopupProps {
  popupOpen: boolean;
  setPopupOpen: (open: boolean) => void;
  onRegister: (activityData: { id?: number; name: string; code: string }) => void;
}

const EconomicActivityPopup: React.FC<EconomicActivityPopupProps> = ({
  popupOpen,
  setPopupOpen,
  onRegister,
}) => {

  // ✅ Validación obligatoria
  const validationSchema = Yup.object({
    name: Yup.string()
      .min(2, 'El nombre debe tener al menos 2 caracteres')
      .required('El nombre de la actividad económica es obligatorio'),

    code: Yup.string()
      .min(2, 'El código debe tener al menos 2 caracteres')
      .max(10, 'El código no puede exceder 10 caracteres')
      .required('El código es obligatorio'),
  });

  // ✅ Formik
  const formik = useFormik({
    initialValues: {
      id: 0,
      name: '',
      code: '',
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      onRegister(values);
      resetForm();
      setPopupOpen(false);
    },
  });

  // ✅ Reset
  useEffect(() => {
    if (!popupOpen) formik.resetForm();
  }, [popupOpen]);

  return (
    <FormModal
      isOpen={popupOpen}
      onClose={() => setPopupOpen(false)}
      title="Agregar Actividad Económica"
      maxWidth="max-w-md"
    >
      <form onSubmit={formik.handleSubmit} className="mt-4">
        
        {/* Nombre */}
        <InputField
          label="Nombre"
          name="name"
          type="text"
          placeholder="Ej: Venta de alimentos"
          iconKey='edit'
          value={formik.values.name}
          onChange={formik.handleChange}
          error={
            formik.touched.name && formik.errors.name
              ? formik.errors.name
              : undefined
          }
        />

        {/* Código */}
        <InputField
          label="Código"
          name="code"
          type="text"
          placeholder="Ej: A1"
          iconKey='hash'
          value={formik.values.code}
          onChange={formik.handleChange}
          error={
            formik.touched.code && formik.errors.code
              ? formik.errors.code
              : undefined
          }
        />

        <button
          type="submit"
          className="w-full mt-3 rounded bg-primary px-4 py-2 font-medium text-white hover:bg-opacity-90"
        >
          Guardar Actividad Económica
        </button>
      </form>
    </FormModal>
  );
};

export default EconomicActivityPopup;
